import noomb from "./assets/noombN.png";
import nuahuleN from "./assets/nuahuleN.png";
import opticsN from "./assets/opticsN.png";
import partyN from "./assets/partyN.png";
import prosN from "./assets/prosN.png";
import sodoxN from "./assets/sodoxN.png";
import cdN from "./assets/SDN.png";
import viskantN from "./assets/viskantN.png";
import zipTreid from "./assets/zipTreid.png";
import rent from "./assets/rentClab.svg";
import ndv from "./assets/ndv.webp";
import art from "./assets/artDoc.svg";

export type ClientsType = {
    img: string,
}

export const clients: ClientsType[] = [
    {img: prosN},
    {img: partyN},
    {img: cdN},
    {img: opticsN},
    {img: nuahuleN},
    {img: noomb},
    {img: sodoxN},
    {img: viskantN},
    {img: zipTreid},
    {img: rent},
    {img: ndv},
    {img: art},
]
